import { SorterResult } from 'antd/lib/table/interface';

import { TableWithForm, TitledContainer } from 'components';

import { useGetHeaders, useMemoState, useTableSearchParams } from 'hooks';

import { ProductDashboardDto } from 'codegen';

import { NewProductButton } from './components';
import { columns, handleProductsTableChange } from './lib';

export const Products = () => {
  const [sortOrderInfo, setSortOrderInfo] = useMemoState<SorterResult<ProductDashboardDto>>({ field: 'order', order: 'descend' });

  const headers = useGetHeaders();

  const { setSearchParams, defaultTableParams } = useTableSearchParams({ defaultSize: 10 });

  return (
    <TitledContainer
      title='Products'
      titleExtraNode={<NewProductButton />}
    >
      <TableWithForm
        horizontalScroll
        id='all-products-table'
        columns={columns(sortOrderInfo)}
        defaultTableParams={defaultTableParams}
        onTableChange={handleProductsTableChange(headers, setSearchParams, setSortOrderInfo)}
      />
    </TitledContainer>
  );
};
